import React, { memo } from 'react';

import IconMC from '../../../../../components/IconMC';

const SuccessActionIcon = ({
  icon, title, subtitle, onClick
}) => (
  <div
    className="tw-flex tw-flex-col tw-items-center tw-gap-1 tw-cursor-pointer"
    onClick={onClick}
  >
    <div className="tw-flex tw-items-center tw-justify-center tw-bg-blue-50 tw-rounded-lg tw-w-10 tw-h-10">
      <IconMC name={icon} className="tw-text-blue-500" />
    </div>
    <p className="tw-text-xs tw-mb-0">{title}</p>
    <p className="tw-text-xs tw-mb-0">{subtitle}</p>
  </div>
);

export default memo(SuccessActionIcon);
